export interface FactoryProfile {
  id: number;
  name: string;
  country: string;
  flag: string;
  city: string;
  address: string;
  founded: number;
  employees: string;
  annualRevenue: string;
  productionCapacity: string;
  category: string;
  categoryIcon: string;
  specialties: string[];
  certifications: string[];
  exportCountries: number;
  rating: number;
  reviews: number;
  responseTime: string;
  image: string;
  coverImage: string;
  description: string;
  products: {
    name: string;
    price: string;
    minOrder: string;
  }[];
  verified: boolean;
  goldSupplier: boolean;
}

export const factoryProfiles: FactoryProfile[] = [
  {
    id: 1,
    name: "Longi Solar Technology Co., Ltd.",
    country: "China",
    flag: "🇨🇳",
    city: "Xi'an, Shaanxi",
    address: "No.1 Longi Avenue, Hi-Tech Zone, Xi'an, Shaanxi 710119, China",
    founded: 2000,
    employees: "25,000+",
    annualRevenue: "$8.5B USD",
    productionCapacity: "50GW Solar Panels/Year",
    category: "Solar Panels",
    categoryIcon: "ri-sun-line",
    specialties: ["Monocrystalline PERC", "Bifacial Modules", "HiMO Series", "Large Format Panels"],
    certifications: ["ISO 9001", "ISO 14001", "IEC 61215", "IEC 61730", "CE", "UL", "MCS"],
    exportCountries: 150,
    rating: 4.9,
    reviews: 3420,
    responseTime: "< 2 hours",
    image: "https://public.readdy.ai/ai/img_res/1da395c40acc7475669bdfff206119e7.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=large%20solar%20panel%20factory%20production%20line%20workers%20assembling%20monocrystalline%20photovoltaic%20modules%20bright%20clean%20modern%20industrial%20facility%20China%20professional%20photography&width=800&height=300&seq=fpc1&orientation=landscape",
    description: "World's largest solar technology company by shipment volume. Longi Solar specializes in monocrystalline silicon products and has been driving the global solar industry toward higher efficiency and lower costs since 2000.",
    products: [
      { name: "Hi-MO 6 Monocrystalline 580W", price: "$115/pc", minOrder: "5 pcs" },
      { name: "Bifacial PERC 550W Module", price: "$128/pc", minOrder: "5 pcs" },
      { name: "Hi-MO X6 700W Large Format", price: "$165/pc", minOrder: "2 pcs" },
    ],
    verified: true,
    goldSupplier: true,
  },
  {
    id: 2,
    name: "CATL (Contemporary Amperex Technology)",
    country: "China",
    flag: "🇨🇳",
    city: "Ningde, Fujian",
    address: "No.2 CATL Road, Jiaocheng District, Ningde, Fujian 352100, China",
    founded: 2011,
    employees: "95,000+",
    annualRevenue: "$44B USD",
    productionCapacity: "300GWh Battery Cells/Year",
    category: "Solar Batteries",
    categoryIcon: "ri-battery-charge-line",
    specialties: ["LiFePO4 Cells", "NMC Batteries", "Sodium-Ion", "Energy Storage Systems"],
    certifications: ["ISO 9001", "ISO 14001", "IATF 16949", "UL 9540", "IEC 62619", "CE", "UN38.3"],
    exportCountries: 60,
    rating: 5.0,
    reviews: 5670,
    responseTime: "< 1 hour",
    image: "https://readdy.ai/api/search-image?query=CATL%20battery%20factory%20modern%20clean%20room%20production%20line%20lithium%20battery%20cells%20assembly%20Ningde%20China%20professional%20photography%20bright%20industrial%20facility&width=300&height=300&seq=fp2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=lithium%20battery%20factory%20large%20clean%20room%20production%20line%20workers%20assembling%20battery%20cells%20modern%20industrial%20facility%20China%20professional%20photography%20bright&width=800&height=300&seq=fpc2&orientation=landscape",
    description: "World's #1 battery manufacturer by market share. CATL supplies batteries to Tesla, BMW, Volkswagen, and 200+ global automakers. Their LiFePO4 technology sets the industry standard for safety and longevity.",
    products: [
      { name: "LiFePO4 100Ah 48V Battery Pack", price: "$380/pc", minOrder: "2 pcs" },
      { name: "5kWh Home Energy Storage", price: "$1,250/unit", minOrder: "1 unit" },
      { name: "100kWh Commercial ESS", price: "$18,500/unit", minOrder: "1 unit" },
    ],
    verified: true,
    goldSupplier: true,
  },
  {
    id: 3,
    name: "Growatt New Energy Technology",
    country: "China",
    flag: "🇨🇳",
    city: "Shenzhen, Guangdong",
    address: "No.28 Guangming Road, Guangming District, Shenzhen, Guangdong 518107, China",
    founded: 2010,
    employees: "3,500+",
    annualRevenue: "$1.2B USD",
    productionCapacity: "10GW Inverters/Year",
    category: "Solar Inverters",
    categoryIcon: "ri-flashlight-line",
    specialties: ["Hybrid Inverters", "String Inverters", "Micro Inverters", "Off-Grid Systems"],
    certifications: ["ISO 9001", "IEC 62109", "CE", "VDE", "TÜV", "UL 1741", "AS/NZS 4777"],
    exportCountries: 100,
    rating: 4.8,
    reviews: 2890,
    responseTime: "< 3 hours",
    image: "https://readdy.ai/api/search-image?query=Growatt%20solar%20inverter%20factory%20production%20line%20Shenzhen%20China%20modern%20clean%20industrial%20facility%20workers%20assembling%20power%20electronics%20professional%20photography&width=300&height=300&seq=fp3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=solar%20inverter%20factory%20production%20line%20workers%20assembling%20power%20electronics%20modern%20clean%20industrial%20facility%20Shenzhen%20China%20professional%20photography%20bright&width=800&height=300&seq=fpc3&orientation=landscape",
    description: "Global leading inverter manufacturer with 10+ million units installed worldwide. Growatt's hybrid inverters are trusted by homeowners and commercial installers in 100+ countries for reliable solar energy conversion.",
    products: [
      { name: "Hybrid Inverter 5kW MPPT", price: "$420/unit", minOrder: "1 unit" },
      { name: "String Inverter 10kW 3-Phase", price: "$680/unit", minOrder: "1 unit" },
      { name: "Off-Grid Inverter 3kW 24V", price: "$280/unit", minOrder: "1 unit" },
    ],
    verified: true,
    goldSupplier: true,
  },
  {
    id: 4,
    name: "Dongguan Marshell Electric Vehicle Co.",
    country: "China",
    flag: "🇨🇳",
    city: "Dongguan, Guangdong",
    address: "No.88 Marshell Road, Houjie Town, Dongguan, Guangdong 523945, China",
    founded: 2003,
    employees: "2,800+",
    annualRevenue: "$320M USD",
    productionCapacity: "80,000 Golf Carts/Year",
    category: "Golf Carts",
    categoryIcon: "ri-car-line",
    specialties: ["Electric Golf Carts", "Utility Vehicles", "Resort Carts", "Custom Fleet"],
    certifications: ["ISO 9001", "ISO 14001", "CE", "EPA", "CARB", "SGS"],
    exportCountries: 80,
    rating: 4.8,
    reviews: 1240,
    responseTime: "< 4 hours",
    image: "https://readdy.ai/api/search-image?query=golf%20cart%20factory%20Dongguan%20China%20production%20line%20workers%20assembling%20electric%20vehicles%20modern%20clean%20industrial%20facility%20professional%20photography%20bright&width=300&height=300&seq=fp4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=electric%20golf%20cart%20factory%20large%20production%20hall%20workers%20assembling%20vehicles%20Dongguan%20China%20modern%20industrial%20facility%20professional%20photography%20bright%20daylight&width=800&height=300&seq=fpc4&orientation=landscape",
    description: "Asia's largest golf cart manufacturer with 20+ years of experience. Marshell supplies electric golf carts and utility vehicles to golf courses, resorts, airports, and industrial facilities in 80+ countries.",
    products: [
      { name: "4-Seater Electric Golf Cart 48V", price: "$4,800/unit", minOrder: "1 unit" },
      { name: "6-Seater Resort Cart 72V", price: "$6,500/unit", minOrder: "1 unit" },
      { name: "Utility Cargo Cart 500kg", price: "$3,200/unit", minOrder: "1 unit" },
    ],
    verified: true,
    goldSupplier: true,
  },
  {
    id: 5,
    name: "Zongshen Power Machinery Co.",
    country: "China",
    flag: "🇨🇳",
    city: "Chongqing",
    address: "No.1 Zongshen Road, Banan District, Chongqing 401320, China",
    founded: 1992,
    employees: "18,000+",
    annualRevenue: "$2.1B USD",
    productionCapacity: "3,000,000 Motorcycles/Year",
    category: "Motorcycles",
    categoryIcon: "ri-motorbike-line",
    specialties: ["Electric Motorcycles", "Gas Motorcycles", "Dirt Bikes", "Racing Bikes"],
    certifications: ["ISO 9001", "ISO 14001", "CE", "Euro 5", "EPA", "DOT", "EEC"],
    exportCountries: 120,
    rating: 4.7,
    reviews: 4560,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=Zongshen%20motorcycle%20factory%20Chongqing%20China%20large%20production%20hall%20workers%20assembling%20motorcycles%20modern%20industrial%20facility%20professional%20photography%20bright%20daylight&width=300&height=300&seq=fp5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=motorcycle%20factory%20large%20production%20line%20workers%20assembling%20bikes%20Chongqing%20China%20modern%20industrial%20facility%20professional%20photography%20bright%20daylight&width=800&height=300&seq=fpc5&orientation=landscape",
    description: "China's top motorcycle manufacturer with 30+ years of history. Zongshen produces 3 million motorcycles annually and exports to 120+ countries. Their electric motorcycle lineup is rapidly expanding to meet global EV demand.",
    products: [
      { name: "Electric Motorcycle 72V 5000W", price: "$1,850/unit", minOrder: "1 unit" },
      { name: "Gas Motorcycle 250cc EFI", price: "$1,200/unit", minOrder: "1 unit" },
      { name: "Electric Dirt Bike 60V", price: "$2,200/unit", minOrder: "1 unit" },
    ],
    verified: true,
    goldSupplier: true,
  },
  {
    id: 6,
    name: "Bafang Electric (Suzhou) Co., Ltd.",
    country: "China",
    flag: "🇨🇳",
    city: "Suzhou, Jiangsu",
    address: "No.3 Bafang Road, Suzhou Industrial Park, Suzhou, Jiangsu 215123, China",
    founded: 2003,
    employees: "4,200+",
    annualRevenue: "$580M USD",
    productionCapacity: "5,000,000 E-Bike Motors/Year",
    category: "Scooters & E-Bikes",
    categoryIcon: "ri-e-bike-line",
    specialties: ["Mid-Drive Motors", "Hub Motors", "E-Bike Systems", "Electric Scooters"],
    certifications: ["ISO 9001", "ISO 14001", "CE", "EN 15194", "UL 2849", "RoHS", "SGS"],
    exportCountries: 90,
    rating: 4.9,
    reviews: 3210,
    responseTime: "< 2 hours",
    image: "https://readdy.ai/api/search-image?query=Bafang%20e-bike%20motor%20factory%20Suzhou%20China%20clean%20production%20line%20workers%20assembling%20electric%20bike%20motors%20modern%20industrial%20facility%20professional%20photography%20bright&width=300&height=300&seq=fp6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=electric%20bike%20e-bike%20factory%20production%20line%20workers%20assembling%20motors%20Suzhou%20China%20modern%20clean%20industrial%20facility%20professional%20photography%20bright%20daylight&width=800&height=300&seq=fpc6&orientation=landscape",
    description: "World's leading e-bike drive system manufacturer. Bafang's mid-drive motors power millions of e-bikes globally. They supply OEM systems to 1,000+ e-bike brands worldwide and offer complete e-bike assembly solutions.",
    products: [
      { name: "750W Mid-Drive Trekking E-Bike", price: "$1,100/unit", minOrder: "2 units" },
      { name: "Foldable Electric Scooter 48V", price: "$380/unit", minOrder: "5 units" },
      { name: "Fat Tire E-Bike 1000W", price: "$1,350/unit", minOrder: "1 unit" },
    ],
    verified: true,
    goldSupplier: true,
  },
];

export const rfqCategories = [
  "Solar Panels",
  "Solar Batteries",
  "Solar Inverters",
  "Golf Carts",
  "Motorcycles",
  "Scooters & E-Bikes",
  "Sport Clothes",
  "Garden Tools",
  "Complete Solar System",
  "EV Fleet (Mixed)",
];
